import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Turns a raw backend role ("CarehomeEditor") into its localized name via the `userRoles`
 * translation block. Roles are stored and posted as the raw strings, so only the label is translated.
 * Impure so the label follows a language switch, like ngx-translate's own pipe.
 */
@Pipe({
	name: 'roleName',
	pure: false
})
export class RoleNamePipe implements PipeTransform {
	// An impure pipe runs on every change detection pass and the user lists render hundreds of role
	// labels, so resolved names are kept until the language changes.
	private cache = new Map<string, string>();
	private cachedLang: string;

	constructor(private translate: TranslateService) {
	}

	transform(role: string): string {
		if (!role) {
			return '';
		}

		if (this.cachedLang !== this.translate.currentLang) {
			this.cachedLang = this.translate.currentLang;
			this.cache.clear();
		}

		if (this.cache.has(role)) {
			return this.cache.get(role);
		}

		const key = `userRoles.${role}`;
		const translated = this.translate.instant(key);

		// ngx-translate echoes the key back when there is no entry - show the raw role rather than "userRoles.X".
		const name = translated === key ? role : translated;
		this.cache.set(role, name);

		return name;
	}
}
